import { Box, HStack, Link } from '@chakra-ui/react';
import { useUserContext } from 'providers/useUserContext';
import { useEffect, useMemo } from 'react';
import { Navigate, Route, RouteObject, Routes, useLocation, useRoutes } from 'react-router';
import { NavLink } from 'react-router-dom';
import { ProfileEdit } from 'screens/Account/ProfileEdit';
import { ResetPasswordForm } from 'screens/Account/ResetPasswordForm';
import { ServicesHistory } from 'screens/Account/Services/ServicesHistory';
import { VisitsHistory } from 'screens/Account/Visits/VisitsHistory';
import { Checkout } from 'screens/Checkout';
import { ClassScreen } from 'screens/Class';
import { Account } from './screens/Account';
import { Classes } from './screens/Classes';
import { Prices } from './screens/Prices';
import * as Sentry from '@sentry/react';

function App() {
  const { user } = useUserContext();

  useEffect(() => {
    if (user) {
      Sentry.setUser({
        id: user.Id,
        email: user.Email,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [user]);

  return (
    <Box>
      <HStack textTransform="uppercase" fontWeight={500} className="mainAppMenu">
        <Link className="mainMenuElement" as={NavLink} to="/">
          Planning
        </Link>
        <Link className="mainMenuElement" as={NavLink} to="tarifs">
          Tarifs
        </Link>
        <Link className="mainMenuElement" as={NavLink} to="account">
          Mon compte
        </Link>
      </HStack>
      <ScrollToTop />
      <Routes>
        <Route index Component={Classes} />
        <Route path="studio/:id" Component={Classes} />
        <Route path="coach/:id" Component={Classes} />
        <Route path="cours/:id" Component={Classes} />
        <Route path="studio/:id/cours/:type" Component={Classes} />
        <Route path="tarifs" Component={Prices} />
        <Route path="class/:id" Component={ClassScreen} />
        <Route path="class/:id/enrollment" Component={ClassScreen} />
        <Route path="account/*" Component={AccountRoutes} />
        <Route path="checkout" Component={Checkout} />
        <Route path="checkout/id/:productId" Component={Checkout} />
      </Routes>
    </Box>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AccountRoutes() {
  const { isLoggedIn } = useUserContext();

  const routes = useMemo(() => {
    const routes: RouteObject[] = [
      { index: true, Component: Account },
      { path: 'reset-password', Component: ResetPasswordForm },
      { path: '*', Component: () => Navigate({ to: '/account' }) },
    ];

    if (isLoggedIn) {
      routes.push(
        ...[
          { path: 'edit', Component: ProfileEdit },
          { path: 'visits', Component: VisitsHistory },
          { path: 'services', Component: ServicesHistory },
        ],
      );
    }

    return routes;
  }, [isLoggedIn]);

  return useRoutes(routes);
}

export default App;
